import { useState } from "react";
import { CategoryResource } from "../../Resources"; 
import { Actions } from "../utils/actions";
import { ShowAlert } from "../utils/alerts";

const Create = ({ parent, close = () => { } }) => {
    const [alert, setAlert] = useState({});
    const [data, setData] = useState({ parent_id: parent.id });
    const handleInput = (e) => {
        setAlert();
        const n = e.target.name;
        const v = e.target.value;
        setData(values => ({ ...values, [n]: v }));
    }
    const handleSubmit = () => {
        CategoryResource.create(data, (r) => {
            if (r.status) return close();
            setAlert(r?.body);
        });
    }
    const actions = () => {
        return {
            back: close,
            refresh: null,
            save: () => handleSubmit(),
        }
    }
    return (
        <div className="card shadow my-2">
            <div className="card-body p-3">
                <div className="row">
                    <div className="col-12 col-lg-9">
                        <input onChange={handleInput} value={data.name || ""} name="name" type="text" className="form-control" />
                        <ShowAlert alerts={alert} tag="name_error" />
                        <ShowAlert alerts={alert} tag="error" />
                        <span>{parent.title + ">" + (data.name || "")}</span>
                    </div>
                    <div className="col text-end">
                        <div role="group" className="btn-group btn-group-sm">
                            <Actions mod="user" iconOnly="true" actions={actions()} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Create;